import Icon from '@/components/shared/icons'
import DateConvert from '@/utils/date-convert'
import {
	Badge,
	Box,
	Flex,
	Heading,
	Text,
	HStack,
	VStack,
} from '@chakra-ui/react'
import Toast from '../elements/toast'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '@/store/store'
import { ToastConfirm } from '../elements/toast-confirm'
import { removeCouponById } from '@/services/api/coupons/coupons'
import { deleteCouponFn } from '@/store/features/coupons'
import expiredValidator from '@/utils/expired-validator'
import { sessionRefrestUpdate } from '@/store/features/state'
import CouponsEntity, { TypesCoupon } from '@/entities/api/coupons/coupons'
import formatCurrency from '@/utils/price-convert'

const CouponCard = ({
	click,
	coupon,
	token,
}: {
	click: () => void
	coupon: CouponsEntity
	token: string
}) => {
	const dispatch = useDispatch<AppDispatch>()
	const isExpired = expiredValidator(coupon?.expiration.toString() ?? '')

	const removeCouponFn = async (coupon: CouponsEntity) => {
		try {
			ToastConfirm({
				message: '¿Quieres eliminar este elemento?',
				onConfirm: async () => {
					const response = await removeCouponById(token, coupon?._id ?? '')

					if (response?.status === 500 || response?.status === 404) {
						Toast({
							type: 'error',
							message: 'No se pudo eliminar la cupon',
						})
						return
					}

					if (response?.status === 401) {
						Toast({
							type: 'info',
							message: 'La session del usuario a expirado',
						})
						dispatch(sessionRefrestUpdate())
						return
					}

					dispatch(deleteCouponFn(coupon._id ?? ''))
					Toast({
						type: 'success',
						message: 'Se elimino correctamente el cupon',
					})
				},
				onCancel: () => {
					Toast({
						type: 'info',
						message: 'Se cancelo la operacion',
					})
				},
				confirmLabel: 'Eliminar',
				cancelLabel: 'Cancelar',
			})
		} catch (error) {
			Toast({ type: 'error', message: 'No se pudo eliminar el cupon' })
		}
	}

	return (
		<Box
			bg={isExpired ? 'red.200' : 'white'}
			borderRadius='md'
			p='3'
			shadow='sm'
			maxW='xs'
			cursor='pointer'
			position='relative'
		>
			<Box position='absolute' top='1' right='1' zIndex='3'>
				<Icon
					icon='delete'
					click={() => removeCouponFn(coupon)}
					size='sm'
					color='black'
				/>
			</Box>
			<Flex flexDirection='column' alignItems='center' onClick={click}>
				<Text fontSize='xs' fontWeight='200' color='gray.500' mb={3}>
					{DateConvert(coupon?._created ?? 'Sin fecha')}
				</Text>

				<Heading
					as='h5'
					fontSize='sm'
					fontWeight='600'
					color='black'
					textAlign='center'
					wordBreak='break-word'
					whiteSpace='normal'
					mb={2}
				>
					{coupon?.code || 'Sin código'}
				</Heading>

				<VStack mb={2} align='center'>
					<HStack>
						<Text fontSize='xs' fontWeight='600' color='gray.700'>
							Descuento:
						</Text>
						<Text fontSize='xs' fontWeight='400' color='gray.600'>
							{coupon.type === TypesCoupon.AMOUNT &&
								(coupon?.amount ? `${formatCurrency(coupon.amount)}` : 'N/A')}
							{coupon.type === TypesCoupon.DISCOUNT &&
								(coupon?.discount ? `${coupon.discount}%` : 'N/A')}
						</Text>
					</HStack>
				</VStack>

				<Badge
					bg='gray.50'
					color='black'
					p={1.5}
					borderRadius='full'
					fontSize='xs'
					display='flex'
					alignItems='center'
					justifyContent='center'
					mt={1}
				>
					<Icon icon='calendar' size='sm' color='gray' />
					<Text>
						{isExpired ? 'Vencio el' : 'Vence el'}{' '}
						{DateConvert(coupon?.expiration || '')}
					</Text>
				</Badge>
			</Flex>
		</Box>
	)
}

export default CouponCard
